import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {FiWifi} from 'react-icons/fi'
import _ from 'lodash'
import {VmoCreateFirst} from 'vmo-library'

import {getPageSettings} from 'actions/statuspage'
import {CREATE_STATUS_PAGE, GET_PAGE_SETTINGS} from 'actions/types'
import {CreateStatusPage} from 'components/pages/StatusPage/CreateStatusPage'
import StatusPageRoutes from 'navigation/sub-routes/StatusPage/StatusPageRoutes'
import StatusPageMenu from 'navigation/sub-routes/StatusPage/StatusPageMenu'
import PageLoader from 'components/common/PageLoader'
import useApiLoader from 'hooks/pure/useApiLoader'
import StatusPageProvider from 'context/StatusPage.context'
import {Outlet} from 'react-router-dom'

const items = [
  {
    header: 'Eliminate duplicate support tickets',
    subHeader: 'Inform users about the known issue during downtime and eliminate repetitive tickets at a point of time',
  },
  {
    header: 'Display status of each part of your service',
    subHeader: 'Shows complete timeline of status so users can know if there is any downtime in past',
  },
  {
    header: 'Level up your incident communication',
    subHeader: 'Provide quality services using live incident communications with customers',
  },
]

export default function StatusPageLayout() {
  const dispatch = useDispatch()
  const [isStatusModal, setIsStatusModal] = useState(false)
  const [isCreatFirst, setIsCreatFirst] = useState(false)

  const {GetPageSettingsData = {}} = useSelector(state => state.statuspage)
  const {successLabels = []} = useSelector(state => state.apiReducer)

  const {loading} = useApiLoader({label: GET_PAGE_SETTINGS})

  useEffect(() => {
    dispatch(getPageSettings())
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(GetPageSettingsData)) setIsCreatFirst(true)
    else setIsCreatFirst(false)
  }, [isCreatFirst, setIsCreatFirst, GetPageSettingsData])

  useEffect(() => {
    if (successLabels.includes(CREATE_STATUS_PAGE)) dispatch(getPageSettings())
  }, [successLabels, dispatch])

  if (loading) {
    return <PageLoader />
  }

  if (isCreatFirst)
    return (
      <div className="ml-5 mt-5">
        <VmoCreateFirst
          headerIcon={<FiWifi />}
          header="Status Page"
          subHeader="Status page is the communication place for your incident management process."
          items={items}
          primaryButtonProps={{
            buttonText: 'Create Status Page',
            onClick: () => setIsStatusModal(true),
          }}
        />
        {isStatusModal && <CreateStatusPage open={isStatusModal} toggle={setIsStatusModal} />}
      </div>
    )

  return (
    <StatusPageProvider>
      <StatusPageMenu />
      <div className="vmoSideBar-wrap">
        <Outlet />
      </div>
    </StatusPageProvider>
  )
}
